import { Component, Input, OnInit, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { FormControlBase } from '../../common/form-control-base/form-control-base';

@Component({
    selector: 'waf-password-input',
    templateUrl: './password-input.component.html',
    styleUrls: ['./password-input.component.scss'],
    standalone: false
})
export class PasswordInputComponent extends FormControlBase<string> {

  constructor(@Self() @Optional() protected override ngModel: NgControl) {
    super('waf-password-input', ngModel);
}

@Input()
public maxLength: number = 255;

@Input()
public minLength: number;

}
